import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Login Redux States
import { DELETE_USER, GENERATE_PASSWORD } from "./actionType"
//Include Both Helper File with needed methods
import { deleteUser, generatePwd } from "../../../helpers/backend_helper"
import "toastr/build/toastr.min.css"
import toast from "react-hot-toast";
import { deleteUserError, deleteUserSuccess, GeneratePasswordFail, GeneratePasswordSuccess } from "./actions"

function* deleteUserRecord({ payload: { history, id } }) {
    try {
        const response = yield call(deleteUser, id)
        if (response.status === 'error') {
            toast.error(response.message)
        } else {
            yield put(deleteUserSuccess(response))
            toast.success(response.message)
            history.push("/users");
        }
    } catch (error) {
        yield put(deleteUserError(error))
        toast.error(error.response.data.message)
    }
}

function* DeleteUserSaga() {
    yield takeEvery(DELETE_USER, deleteUserRecord)
}

export default DeleteUserSaga

// generate password
function* generatePassword({ payload: { history, id, path } }) {
    const data = {}
    if (id) {
        data["userId"] = id
    }
    try {
        const response = yield call(generatePwd, data)
        if (response.status === 'error') {
            toast.error(response.message)
        } else {
            yield put(GeneratePasswordSuccess(response))
            toast.success(response.message)
            history.push(`/${path}`);
        }
    } catch (error) {
        yield put(GeneratePasswordFail(error))
        toast.error(error.response.data.message)
    }
}

export function* GeneratePasswordSaga() {
    yield takeEvery(GENERATE_PASSWORD, generatePassword)
}